<h1 mat-dialog-title>Confirm</h1>
<div mat-dialog-content>
  <p>{{data.title}}</p>
  <b [innerHTML]="data.subTitle"></b>
</div>
<div mat-dialog-actions>
  <button *ngIf="isShowNoButton" mat-button mat-flat-button color="primary" [mat-dialog-close]="false">No</button>
  <button *ngIf="isShowYesButton" mat-button mat-flat-button color="warn" [mat-dialog-close]="true"
    cdkFocusInitial>{{yesButtonText}}</button>
</div>